import { axios } from '../config/axios';

const endPoint = '/project/device';

const getPendingApprovalList = async () => {
    return axios.get(`${endPoint}/pending-approval`);
}

const submitExceptionDecision = async (deviceId, labNo, seatNo, status) => {
    return axios.patch(`${endPoint}/exception/exception-decision`, { deviceId, labNo, seatNo, status });
}

export { getPendingApprovalList, submitExceptionDecision }
